<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">{{title}}</v-card-title>
      <v-card-text class="body-2 pa-0" style="max-height: 300px; overflow-y: scroll;">
        <v-simple-table dense>
          <template v-slot:default>
            <tbody ref="sortableTbody">
              <tr
                v-for="(item, index) in localItems"
                :key="item.key"
                :data-id="item.key" 
                style="border-bottom:1px solid #ededed"
              >
                <td 
                  v-if="isSort" 
                  class="sort-handle" 
                  style="width: 20px; cursor: grab;"
                >
                  <v-icon small>mdi-arrow-all</v-icon>
                </td>
                
                <td>{{item.title}}</td>
                
                <td style="width: 50px; text-align: right;">
                  <v-checkbox
                    class="mt-1 pb-2 d-inline-block"
                    v-model="localItems[index].value"
                    label=""
                    :true-value="true"
                    :false-value="false"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="$emit('input')">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
import Sortable from 'sortablejs';

export default {
  name: 'TableColsShowHideModal',
  props: {
    value: Boolean,
    title: String,
    items: {
      type: Array,
      required: true
    },
    // New prop for conditional sorting
    isSort: { 
        type: Boolean,
        default: false // Default to false if not provided
    }
  },
  data() {
    return {
      localItems: [],
      sortable: null,
    }
  },
  watch: {
    items: {
      immediate: true,
      handler(newItems) {
        this.localItems = newItems ? JSON.parse(JSON.stringify(newItems)) : [];
      }
    },
    value(val) {
      if (val && this.isSort) { // Only initialize if modal is open AND sorting is enabled
        this.$nextTick(() => {
          this.initSortable();
        });
      } else {
        this.destroySortable();
      }
    },
    // Watch the isSort prop to dynamically enable/disable sorting
    isSort(val) {
        if (this.value && val) {
             this.$nextTick(() => {
                this.initSortable();
            });
        } else {
            this.destroySortable();
        }
    }
  },
  mounted() {
    // Only check on initial mount if dialog is open AND sorting is enabled
    if (this.value && this.isSort) {
      this.$nextTick(() => {
        this.initSortable();
      });
    }
  },
  beforeDestroy() {
    this.destroySortable();
  },
  methods: {
    initSortable() {
      // Return if Sortable is already initialized, the ref isn't available, or sorting is disabled
      if (this.sortable || !this.$refs.sortableTbody || !this.isSort) return;

      this.sortable = Sortable.create(this.$refs.sortableTbody, {
        handle: '.sort-handle', // Class of the element to drag by
        animation: 150,
        onEnd: this.onSortEnd,
      });
    },

    destroySortable() {
      if (this.sortable) {
        this.sortable.destroy();
        this.sortable = null;
      }
    },

    onSortEnd(event) {
      const { oldIndex, newIndex } = event;

      // Update the local data array (localItems) after a drag-and-drop action
      if (newIndex !== oldIndex) {
        const itemToMove = this.localItems.splice(oldIndex, 1)[0];
        this.localItems.splice(newIndex, 0, itemToMove);
      }
    },

    save() {
      this.$emit('updated', this.localItems);
    }
  }
}
</script>

<style scoped>
.sort-handle {
  cursor: grab;
  color: grey; 
}
td {
  vertical-align: middle;
}
/* Important for SortableJS: ensures the items are draggable */
tbody {
  display: table-row-group;
}
</style>



// WEBPACK FOOTER //
// TableColsShowHideModal.vue?63f29121